<template>
	<div>
		<!-- Cliente -->
		<div v-if="$route.name == 'ClientDetail'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				@click="$store.commit('userrequests/setNewRequestModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nueva Solicitud</p>
			</v-btn>
		</div>

		<!-- Empresa -->
		<div v-if="$route.name == 'Companies'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				@click="$store.commit('companies/setNewCompanyModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nueva Empresa</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'Roles'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['create_company_roles'])"
				@click="addRole"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Rol Empresa</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'CompanyConcepts'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['create_company_concepts'])"
				@click="$store.commit('companies/setNewCompanyConceptModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Concepto</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'ProjectDestinies'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['create_company_project_types'])"
				@click="$store.commit('companies/setNewDestinyModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Destino</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'CompanyUnarchiveValues'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['create_company_project_types'])"
				@click="$store.commit('companies/setNewUnarchiveValueModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Valor Desarchivo</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'ProjectTypes'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				class="mr-2"
				v-if="$checkPermissions(['create_company_project_types'])"
				@click="$store.commit('companies/setNewCategoryProjectTypeModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nueva Categoría</p>
			</v-btn>
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['create_company_project_types'])"
				@click="$store.commit('companies/setNewProjectTypeModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Tipo de Proyecto</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'Users'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['create_users'])"
				@click="addUser"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Agregar Usuario a Empresa</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'CRM'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['edit_crm'])"
				@click="newContactModal"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Contacto</p>
			</v-btn>

			<v-menu offset-y :close-on-content-click="false" v-if="header_columns">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						small
						color="#959595"
						class="mr-2"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon dark>mdi-cog-outline</v-icon>
					</v-btn>
				</template>
				<div class="pa-2 white">
					<p class="mb-0 caption font-weight-bold">Selecciona las columnas a visualizar</p>
					<v-checkbox v-model="header_columns.id" color="black" label="ID" hide-details dense @change="changeColumns"></v-checkbox>
					<v-checkbox v-model="header_columns.user" color="black" label="Nombre" hide-details dense @change="changeColumns"></v-checkbox>
					<!-- <v-checkbox v-model="header_columns.address" color="black" label="Dirección" hide-details dense @change="changeColumns"></v-checkbox> -->
					<v-checkbox v-model="header_columns.project_detail" color="black" label="Proyecto" hide-details dense @change="changeColumns"></v-checkbox>
					<!-- <v-checkbox v-model="header_columns.details" color="black" label="Tipo Proyecto" hide-details dense @change="changeColumns"></v-checkbox> -->
					<!-- <v-checkbox v-model="header_columns.message" color="black" label="Último Mensaje" hide-details dense @change="changeColumns"></v-checkbox> -->
					<v-checkbox v-model="header_columns.responsible" color="black" label="Responsable" hide-details dense @change="changeColumns"></v-checkbox>
					<v-checkbox v-model="header_columns.schedule" color="black" label="Estado Agenda / Desarchivo" hide-details dense @change="changeColumns"></v-checkbox>
					<!-- <v-checkbox v-model="header_columns.schedule_user" color="black" label="Usuario Responsable VT" hide-details dense @change="changeColumns"></v-checkbox> -->
					<!-- <v-checkbox v-model="header_columns.type" color="black" label="Tipo de Agendamiento" hide-details dense @change="changeColumns"></v-checkbox> -->
					<v-checkbox v-model="header_columns.created_at" color="black" label="Fecha Creación" hide-details dense @change="changeColumns"></v-checkbox>
					<v-checkbox v-model="header_columns.actions" color="black" label="Acciones" hide-details dense @change="changeColumns"></v-checkbox>
				</div>
			</v-menu>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						depressed
						:color="$store.state.companies.userCompanyConnectedStatus?.status == 1 ? 'success':'error'"
						x-small
						:dark="!$store.state.companies.loadingUserCompanyConnectedStatus"
						fab
						class="ml-2 custom-size-button"
						:disabled="$store.state.companies.loadingUserCompanyConnectedStatus"
						:loading="$store.state.companies.loadingUserCompanyConnectedStatus"
						v-bind="attrs"
						v-on="on"
						@click="toogleConnectedStatus()"
					>
						<v-icon small>{{$store.state.companies.userCompanyConnectedStatus?.status == 1 ? 'mdi-account-badge-outline':'mdi-account-cancel-outline'}}</v-icon>
					</v-btn>
				</template>
				<span>{{$store.state.companies.userCompanyConnectedStatus?.status == 1 ? 'Chat: Disponible':'Chat: No Disponible'}}</span>
			</v-tooltip>
		</div>
		<div v-if="$route.name == 'Conversation'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['edit_crm']) && $store.state.crm.conversation && userInfo.name && userInfo.email"
				@click="replicateContactModal"
			>
				<v-icon small>mdi-content-duplicate</v-icon>
				<p class="mb-0 ml-2 caption">Replicar</p>
			</v-btn>
		</div>
		<div class="d-flex" v-if="$route.name == 'Schedules'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['schedule_access'])"
				@click="$store.commit('schedule/setNewScheduleModal', true)"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nueva Agenda</p>
			</v-btn>
			<div
				v-if="$store.state.schedule.userGoogleCalendar"
				:class="$vuetify.breakpoint.mobile ? '':'ml-3'">
				<v-btn
					depressed
					color="#959595"
					small
					dark
					class="mr-2"
					@click="syncCalendarAgenda"
				>
					<v-icon small>mdi-google</v-icon>
					<p class="mb-0 ml-2 caption">Sincronizar Calendar</p>
				</v-btn>
				<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							depressed
							color="#FF120B"
							small
							dark
							class="rounded"
							@click="detachCalendar"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small color="white">mdi-calendar-remove-outline</v-icon>
						</v-btn>
					</template>
					<span>Desasociar Calendar</span>
				</v-tooltip>
			</div>
			<v-btn
				depressed
				color="#959595"
				small
				dark
				:class="$vuetify.breakpoint.mobile ? '':'ml-3'"
				v-else
				@click="toAsociateCalendar"
			>
				<v-icon small>mdi-google</v-icon>
				<p class="mb-0 ml-2 caption">Asociar Google Calendar</p>
			</v-btn>
		</div>
		<div v-if="$route.name == 'PreProjects'">
			<v-menu offset-y :close-on-content-click="false" v-if="preproject_header_columns">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						dark
						small
						color="#959595"
						class="mr-2"
						v-bind="attrs"
						v-on="on"
					>
						<v-icon dark>mdi-cog-outline</v-icon>
					</v-btn>
				</template>
				<div class="pa-2 white">
					<p class="mb-0 caption font-weight-bold">Selecciona las columnas a visualizar</p>
					<v-checkbox v-model="preproject_header_columns.id" color="black" label="ID" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.client" color="black" label="Cliente" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.address" color="black" label="Dirección" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.rol" color="black" label="Rol" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.project_name" color="black" label="Proyecto" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.entity" color="black" label="Municipalidad" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.unarchive" color="black" label="Desarchivo Municipal" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.instalations" color="black" label="Instalaciones" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.cbr" color="black" label="Conservador Bienes Raíces" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.sii" color="black" label="SII" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.sec" color="black" label="SEC" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.responsible" color="black" label="Profesional Encargado" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.observation" color="black" label="Observación" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.status" color="black" label="Estado" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
					<v-checkbox v-model="preproject_header_columns.actions" color="black" label="Acciones" hide-details dense @change="changeColumnsPreProject"></v-checkbox>
				</div>
			</v-menu>
		</div>
		<div class="d-flex" v-if="$route.name == 'Client'">
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['edit_crm'])"
				@click="newCRMFromClient"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo CRM / Solicitud</p>
			</v-btn>
		</div>
		<div class="d-flex" v-if="$route.name == 'Contracts'">
			<ContractLeftButtons />
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['edit_contracts'])"
				@click="newContract"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Contrato</p>
			</v-btn>
		</div>
		<div class="d-flex" v-if="$route.name == 'Budgets'">
			<BudgetLeftButtons />
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['view_budgets'])"
				@click="newBudget"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Presupuesto</p>
			</v-btn>
		</div>
		<div class="d-flex" v-if="$route.name == 'Reports'">
			<ReportLeftButtons />
			<v-btn
				depressed
				color="#FF120B"
				small
				dark
				v-if="$checkPermissions(['edit_crm'])"
				@click="newReport"
			>
				<v-icon small>mdi-plus</v-icon>
				<p class="mb-0 ml-2 caption">Nuevo Informe</p>
			</v-btn>
		</div>
		<div class="d-flex" v-if="$route.name == 'BudgetContractSerialsTable'">
			<SerialsTabletLeftButtons />
		</div>
	</div>
</template>

<script>
import {redirectToGoogle, getEvents, removeGoogleCalendarAssociation} from '@/helpers/api/schedule'
import BudgetLeftButtons from '@/components/Layout/Header/Parts/BudgetLeftButtons'
import ReportLeftButtons from '@/components/Layout/Header/Parts/ReportLeftButtons'
import ContractLeftButtons from '@/components/Layout/Header/Parts/ContractLeftButtons'
import SerialsTabletLeftButtons from '@/components/Layout/Header/Parts/SerialsTabletLeftButtons'

export default {
	name: 'ActionButtons',
	components: {BudgetLeftButtons, ReportLeftButtons, ContractLeftButtons, SerialsTabletLeftButtons},
	computed: {
		userInfo(){
			if(this.$store.state.crm.conversation?.user){
				const user = this.$store.state.crm.conversation?.user
				if(user && user.user && user.user.profile){
					return {
						name: user.user.profile.name,
						email: user.user.email,
						phone: user.user.profile.phone,
						account: true
					}
				}
				return {
					name: user.name,
					email: user.email,
					phone: user.phone,
				}
			}
			return null
		},
	},
	data: () => ({
		header_columns: {
			id: true,
			user: true,
			project_detail: true,
			address: true,
			// message: true,
			schedule: true,
			schedule_user: true,
			details: true,
			created_at: true,
			actions: true,
		},
		preproject_header_columns: null
	}),
	mounted(){
		this.header_columns = this.$store.state.crm.listingColumns
		this.preproject_header_columns = this.$store.state.preprojects.listingColumns
		if(this.$store.state.schedule.userGoogleCalendar){
			this.syncCalendarAgenda()
		}
	},
	methods: {
		toogleConnectedStatus(){
			const data = {
				status: this.$store.state.companies.userCompanyConnectedStatus?.status == 2 ? 1 : 2
			}
			this.$store.dispatch('companies/updateUserCompanyConnectedStatus', data)
		},
		changeColumns(){
			this.$store.commit('crm/setListingColumns', this.header_columns)
		},
		changeColumnsPreProject(){
			this.$store.commit('preprojects/setListingColumns', this.preproject_header_columns)
		},
    addUser() {
			this.$store.commit('users/setNewUserModalEditing', null)
			this.$store.commit('users/setNewUserModal', true)
    },
		newContactModal(){
			this.$store.commit('crm/setNewContactModal', true)
			this.$store.commit('crm/setNewContactModalData', null)
		},
		replicateContactModal(){
			const data = {
				user_name: this.userInfo.name,
				user_email: this.userInfo.email,
				user_phone: this.userInfo.phone,
				project_detail: this.$store.state.crm.conversation.project_info?.project_detail,
				address: this.$store.state.crm.conversation.project_info?.address?.address,
				coordinates: this.$store.state.crm.conversation.project_info?.address?.coordinates,
				project_type_id: this.$store.state.crm.conversation.project_info?.project_type?.id,
				disable_user: true
			}
			this.$store.commit('crm/setNewContactModalData', data)
			this.$store.commit('crm/setNewContactModal', true)
		},
		newCRMFromClient(){
			const userInfo = this.$store.state.users.client
			const data = {
				user_name: userInfo.profile?.name,
				user_email: userInfo.email,
				lastname: userInfo.profile?.lastname,
				second_lastname: userInfo.profile?.second_lastname,
				user_phone: userInfo.profile?.phone,
				disable_user: true
			}
			this.$store.commit('crm/setNewContactModalData', data)
			this.$store.commit('crm/setNewContactModal', true)
		},
		newContractCategory(){
			this.$store.commit('contracts/setModalCategoryEditing', null)
			this.$store.commit('contracts/setModalCategory', true)
		},
		newContractSection(){
			this.$store.commit('contracts/modalCategoryEditing', null)
			this.$store.commit('contracts/modalCategory', true)
		},
    addRole() {
			this.$store.commit('companies/setNewRoleModalEditing', null)
			this.$store.commit('companies/setNewRoleModal', true)
    },
		newContract(){
			this.$store.commit('contracts/setModalContract', true)
		},
		newBudget(){
			this.$store.commit('budget/setModalNewBudget', true)
		},
		newReport(){
			this.$store.commit('reports/setConfirmNewReportModal', {show: true})
		},
		async syncCalendarAgenda(){
			const events = await getEvents()
			if(events.code == 200){
				this.$store.dispatch('schedule/getUserSchedule')
				const messageData = {
					message: 'Sincronización realizada correctamente',
					title: 'Sincronización Completa',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la sincronización por favor intenta nuevamente',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		async toAsociateCalendar(){
			const redirect = await redirectToGoogle()
			if(redirect.code == 200){
				window.location.href = redirect.url
			}
		},
		async detachCalendar(){
			try {
				await removeGoogleCalendarAssociation()
				localStorage.removeItem('g_calendar')
				this.$store.dispatch('schedule/getUserSchedule')
				const messageData = {
					message: 'Desasociación realizada correctamente',
					title: 'Desasociación Completa',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			} catch (error) {
				const messageData = {
					message: 'Ha ocurrido un error, por favor intenta nuevamente',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	}
};
</script>
<style scoped>
.custom-size-button.v-btn--fab.v-size--x-small{
	width: 28px;
	height: 28px;
}
</style>